import React from "react";
import { Dialog } from "primereact/dialog";
import { MdClose, MdPerson, MdBusiness, MdChevronRight } from "react-icons/md";
import styles from "./AccountTypeModal.module.css";

export type AccountType = "customer" | "corporate";

interface AccountTypeModalProps {
  visible: boolean;
  onHide: () => void;
  /** Called when the user taps Customer or Corporate */
  onSelect: (accountType: AccountType) => void;
}

export default function AccountTypeModal({
  visible,
  onHide,
  onSelect,
}: AccountTypeModalProps) {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      showHeader={false}
      modal
      dismissableMask
      // dismissableMask={false}
      className={styles.dialog}
      contentClassName={styles.dialogContent}
    >
      <div className={styles.modal}>
        <div className={styles.hero}>
          <button
            type="button"
            className={styles.closeBtn}
            aria-label="Close"
            onClick={onHide}
          >
            <MdClose size={20} />
          </button>
          <span className={styles.heroBadge} style={{ color: "black" }}>
            Mechmiles
          </span>
        </div>

        <div className={styles.body}>
          <h2 className={styles.title}>Choose the type of login</h2>
          <p className={styles.subtitle}>Select your account type</p>

          <button
            type="button"
            className={styles.typeCard}
            onClick={() => onSelect("customer")}
          >
            <span className={styles.typeIcon}>
              <MdPerson size={22} />
            </span>
            <span className={styles.typeText}>
              <span className={styles.typeTitle}>Customer</span>
              <span className={styles.typeDesc}>
                Personal vehicle maintenance
              </span>
            </span>
            <MdChevronRight size={20} className={styles.typeArrow} />
          </button>

          <button
            type="button"
            className={styles.typeCard}
            onClick={() => onSelect("corporate")}
          >
            <span className={styles.typeIcon}>
              <MdBusiness size={22} />
            </span>
            <span className={styles.typeText}>
              <span className={styles.typeTitle}>Corporate</span>
              <span className={styles.typeDesc}>
                Fleet management &amp; enterprise
              </span>
            </span>
            <MdChevronRight size={20} className={styles.typeArrow} />
          </button>
        </div>
      </div>
    </Dialog>
  );
}
